export default __webpack_public_path__ + "static/media/qr.a691192f.svg";